import { apiRequest } from "../http";

// 文件批量上传
export const uploadFiles = (params) =>
  apiRequest.post("/student/uploadImages", params, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const uploadFilesUnLogin = (params) =>
  apiRequest.post("/student/uploadImagesUnLogin", params, {
    headers: { "Content-Type": "multipart/form-data" },
  });

// 提交
export const saveFeedback = (params) => apiRequest.post("/student/opinionFeedback", params);
export const saveFeedbackUnLogin = (params) => apiRequest.post("/student/opinionFeedbackUnLogin", params);
